export default __webpack_public_path__ + "locales/ar-SA/VersionHistory.json?hash=402a4736f558cdc7369a48417b30e210";